import React from "react";
import { Link } from "react-router-dom";

export default function AccessDenied() {
  return (
    <div>
      <div className="main-content">
        <div className="page-content">
          <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
            <div className="text-center">
                <h1 className="display-1 fw-bold text-danger">403</h1>
                <h2 className="mb-4">Access Denied</h2>
                <p className="mb-4 text-muted">
                    You do not have the required permissions to view this page.
                </p>
                <Link to="/" className="btn btn-primary">
                    Go to Homepage
                </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
